// local
import { CA_GOV_URL, CA_PROP_40_URL } from './constants.js';
// packages

import { createFeed } from './stores.js';

import {
  renderSvelteComponent,
  findElementInShadowDom,
  findElementByIdInShadowDom,
} from './utils/render.js';

// components
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';

const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const [govfeed, prop40] = await Promise.all([
    createFeed(CA_GOV_URL),
    createFeed(CA_PROP_40_URL),
  ]);

  const atAGlanceRaces = [
    {
      id: 'CA-6123',
      label: 'Governor',
      feed: govfeed,
    },
    {
      id: 'CA-84439',
      label: 'Prop. 40: One-time billionaire tax',
      feed: prop40,
    },
  ];

  // Each feed is a per-race file (RACE_URL), so the feed already is the race
  atAGlanceRaces.forEach((/** @type {any} */ r) => {
    r['store'] = r['feed'];
  });

  let aagContainer = findElementByIdInShadowDom('aag-ca');
  if (!aagContainer) return;

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */ (aagContainer),
    {
      feed: atAGlanceRaces,
      crosswalk,
      // 'primary' shows the primary-only lines (top two advance, leading
      // candidates); 'general' hides them
      cycle: 'general',
      // true to show "*"" next to incumbents, and "* Incumbent" in the legend
      showIncumbents: true,
    }
  );
}

main().catch(console.error);
